<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import Card from '../../../../components/ui/Card.vue'
import ContentBody from '../../../../components/ui/ContentBody.vue'
import ContentHeader from '../../../../components/ui/ContentHeader.vue'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'

const { getCrumbs } = useLayoutCrud()

const step = ref(getCrumbs().length - 1)

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name } = currentRoute

	function getCrumbs() {
		const pathArray = (useRouter().currentRoute.meta!.breadcrumb as string)
			.split('/')
			.filter((crumb) => crumb != '')

		return pathArray.map((crumb, index) => {
			return {
				name: crumb,
				step: index,
			}
		})
	}

	return { getCrumbs, name }
}
</script>

<template>
	<div class="flex justify-center flex-col">
		<ContentHeader>
			<Breadcrumb
				v-model="step"
				:icon="false"
				:crumbs="getCrumbs()"
				transform="none"
				class="breadcrumb__internal flex justify-start"
			/>
		</ContentHeader>
		<ContentBody>
			<Card class="card">
				<slot />
			</Card>
		</ContentBody>
	</div>
</template>

<style scoped>
.card {
	@apply px-20 py-8 bg-white w-full;
}

.active {
	@apply border-blue-600;
}
</style>
